"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreenameNetwork = void 0;
var FreenameItemType;
(function (FreenameItemType) {
    FreenameItemType["TLD"] = "TLD";
    FreenameItemType["SECOND_LEVEL_DOMAIN"] = "SECOND_LEVEL_DOMAIN";
    FreenameItemType["SUB_DOMAINED_DOMAIN"] = "SUB_DOMAINED_DOMAIN";
})(FreenameItemType || (FreenameItemType = {}));
var FreenameNetwork;
(function (FreenameNetwork) {
    FreenameNetwork["POLYGON"] = "polygon";
    FreenameNetwork["POLYGON_MUMBAI"] = "polygon-mumbai";
    FreenameNetwork["ETHEREUM"] = "ethereum";
    FreenameNetwork["BSC"] = "bsc";
})(FreenameNetwork = exports.FreenameNetwork || (exports.FreenameNetwork = {}));
